// src/app/home/home.component.ts
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

// Example: if you have a login component or footer component
import { LoginGmailComponent } from '../login-gmail/login-gmail.component';
import { FooterComponent } from '../footer/footer.component';

@Component({
  selector: 'home-page',
  standalone: true,
  imports: [
    CommonModule,
    LoginGmailComponent,
    FooterComponent
  ],
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.css']
})
export class HomePageComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {
    // If user is already logged in, redirect to appropriate route
    this.redirectIfLoggedIn();
  }

  private redirectIfLoggedIn(): void {
    const storedUser = localStorage.getItem('googleUser');
    if (storedUser) {
      try {
        const user = JSON.parse(storedUser);
        if (user && user.email) {
          const userRole = localStorage.getItem('userRole');
          if (userRole === 'admin') {
            console.log('🔄 Home: User already logged in as admin, redirecting to /admin');
            this.router.navigate(['/admin']);
          } else {
            console.log('🔄 Home: User already logged in, redirecting to /app');
            this.router.navigate(['/app']);
          }
        }
      } catch {
        // Invalid localStorage data, stay on home page for fresh login
        localStorage.removeItem('googleUser');
        localStorage.removeItem('userRole');
      }
    }
  }
}
